<style scoped lang="scss" type="text/scss">
    .information-container {
        display: flex;
        align-items: flex-start;
        position: absolute;
        width: 100%;
        height: 100%;

        .session-selector-panel-wrap {
            width: 15rem;
            max-height: 100%;
            overflow: auto;
            margin-right: 1rem;
        }

        .content-wrap {
            flex: 1;
            max-height: 100%;
            overflow: hidden;
        }

        .image-download-panel {
            position: absolute;
            right: 5.5rem;
            top: 0;
        }

        .collect-download-panel {
            position: absolute;
            right: 11rem;
            top: 0;
        }

        .select-year-panel {
            position: absolute;
            right: 16.5rem;
            top: 0;
        }

        .file-download-panel {
            position: absolute;
            right: 0;
            top: 0;
        }
    }
</style>

<template>
    <div class="information-container">
        <card class="session-selector-panel-wrap">
            <session-selector-panel></session-selector-panel>
        </card>
        <card class="content-wrap">
            <content-component></content-component>
        </card>
<!--        <select-year-panel class="select-year-panel"></select-year-panel>-->
        <collect-download-panel class="collect-download-panel"></collect-download-panel>
        <image-download-panel class="image-download-panel"></image-download-panel>
        <file-download-panel class="file-download-panel"></file-download-panel>
    </div>
</template>

<script>
    import Card from '../../../../components/card/index';
    import SessionSelectorPanel from '../../../sub-components/session-selector-panel/index';
    import ContentComponent from './content-component/index';
    import FileDownloadPanel from './download-panel/file';
    import ImageDownloadPanel from './download-panel/image';
    import CollectDownloadPanel from './download-panel/collect';
    // import SelectYearPanel from './download-panel/select';

    export default {
        name: '',
        components: {
            Card,
            SessionSelectorPanel,
            ContentComponent,
            FileDownloadPanel,
            ImageDownloadPanel,
            CollectDownloadPanel,
            // SelectYearPanel
        },
        data () {
            return {};
        }
    };
</script>
